import SpiltBillQrCode from 'components/Form/SplitBill/ItemsQrCode';

import Layout from 'components/Layout';

import { PlacingPaymentConsumer } from 'contexts/placingPayment';
import styled, { css } from 'styled-components';

const Card = styled.div`
  width: 600px;
  text-align: center;
  background: ${({ theme: { color } }) => color.white};
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 48px;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      display: flex;
      flex-direction: column;
      padding: 16px;
      width: 500px;
    }
  `}

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('xs')} {
      display: flex;
      flex-direction: column;
      padding: 16px;
      max-width: 310px;
    }
  `}
`;

const Center = styled.div`
  position: fixed; /* or absolute */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const PreItems = () => {
  return (
    <PlacingPaymentConsumer>
      {({ paymentInfo }) => {
        return (
          <Layout paymentInfo={paymentInfo} isEmptyPage>
            <Center>
              <Card>
                <SpiltBillQrCode />
              </Card>
            </Center>
          </Layout>
        );
      }}
    </PlacingPaymentConsumer>
  );
};

export default PreItems;
